import type { PublicItemDTO } from "@ultradrive/shared-types";

// Tile grid for the public album. Mirrors the dashboard's PhotosView
// minimum-160px column rule. Click → open lightbox.

export function PosterGrid(props: {
  items: PublicItemDTO[];
  onOpen: (index: number) => void;
  token: string;
}) {
  return (
    <div
      className="grid gap-2"
      style={{ gridTemplateColumns: "repeat(auto-fill,minmax(160px,1fr))" }}
    >
      {props.items.map((item, i) => (
        <Tile key={item.id} item={item} onOpen={() => props.onOpen(i)} />
      ))}
    </div>
  );
}

function Tile(props: { item: PublicItemDTO; onOpen: () => void }) {
  const { item } = props;
  return (
    <button
      type="button"
      onClick={props.onOpen}
      className="group relative aspect-square overflow-hidden rounded-lg bg-zinc-100 dark:bg-zinc-900 ring-1 ring-zinc-200 dark:ring-zinc-800 hover:ring-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
      aria-label={item.name}
    >
      {item.thumbnailUrl ? (
        <img
          src={item.thumbnailUrl}
          alt={item.name}
          loading="lazy"
          decoding="async"
          className="absolute inset-0 h-full w-full object-cover"
        />
      ) : (
        <div className="absolute inset-0 flex items-center justify-center text-3xl text-zinc-400 dark:text-zinc-600">
          {item.isVideo ? "▶" : "🖼"}
        </div>
      )}
      {item.isVideo ? (
        <span className="absolute bottom-1 right-1 rounded bg-black/70 px-1.5 py-0.5 text-[10px] font-medium text-white">
          VIDEO
        </span>
      ) : null}
      {item.isCold ? (
        <span className="absolute bottom-1 left-1 rounded bg-blue-900/70 px-1.5 py-0.5 text-[10px] font-medium text-white">
          ARCHIVED
        </span>
      ) : null}
    </button>
  );
}
